import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { PullToRefreshProvider } from './context/PullToRefreshContext';
import Layout from './components/Layout';

// Sayfalar — lazy import
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import TaskListPage from './pages/TaskListPage';
import TaskDetailPage from './pages/TaskDetailPage';
import TaskCompletePage from './pages/TaskCompletePage';
import LeavePage from './pages/LeavePage';
import ReportPage from './pages/ReportPage';
import CustomerListPage from './pages/CustomerListPage';
import CustomerDetailPage from './pages/CustomerDetailPage';
import NotificationPage from './pages/NotificationPage';
import FeedbackPage from './pages/FeedbackPage';
import CalendarPage from './pages/CalendarPage';

// Token yoksa login'e yönlendir (Layout yok — çocuk tam ekran kendi tasarımında)
function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-800">
        <div className="w-8 h-8 border-4 border-brand-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function SalesLayoutRoute({ children }) {
  return (
    <PrivateRoute>
      <Layout>{children}</Layout>
    </PrivateRoute>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<PrivateRoute><HomePage /></PrivateRoute>} />
      <Route path="/satis" element={<SalesLayoutRoute><TaskListPage /></SalesLayoutRoute>} />
      <Route path="/satis/tasks/:id" element={<SalesLayoutRoute><TaskDetailPage /></SalesLayoutRoute>} />
      <Route path="/satis/tasks/:id/complete" element={<SalesLayoutRoute><TaskCompletePage /></SalesLayoutRoute>} />
      <Route path="/satis/leave" element={<SalesLayoutRoute><LeavePage /></SalesLayoutRoute>} />
      <Route path="/satis/reports" element={<SalesLayoutRoute><ReportPage /></SalesLayoutRoute>} />
      <Route path="/satis/customers" element={<SalesLayoutRoute><CustomerListPage /></SalesLayoutRoute>} />
      <Route path="/satis/customers/:id" element={<SalesLayoutRoute><CustomerDetailPage /></SalesLayoutRoute>} />
      <Route path="/satis/notifications" element={<SalesLayoutRoute><NotificationPage /></SalesLayoutRoute>} />
      <Route path="/satis/feedback" element={<SalesLayoutRoute><FeedbackPage /></SalesLayoutRoute>} />
      <Route path="/calendar" element={<SalesLayoutRoute><CalendarPage /></SalesLayoutRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <PullToRefreshProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AppRoutes />
        </BrowserRouter>
      </PullToRefreshProvider>
    </AuthProvider>
  );
}
